import { TextOrLinkData } from "@Src/hubs/chat/dtos/TextOrLinkData";
import { Space, Typography, Button, Image } from "antd";
const { Paragraph, Title, Link, Text } = Typography;
import { getTextAndLinks } from "../TextBubbleHelper";
import { ClientRole } from "@Src/hubs/chat/dtos/ClientRole";

interface SmartIncludeChatBubbleProps {
    textOrLinkArray: Array<TextOrLinkData>;
    senderRole: ClientRole;
    url?: string;
    image: string;
    title: string;
    itemNumber: string;
}

const SmartIncludeChatBubble = ({
    textOrLinkArray,
    senderRole,
    url,
    image,
    title,
    itemNumber,
}: SmartIncludeChatBubbleProps): JSX.Element => {
    const handleViewButtonClick = (): void => {
        window.open(url, "_blank");
    };

    return (
        <>
            <Space
                className="chat-bubble chat-bubble--extra-padding"
                direction="vertical"
                size={0}
            >
                <Text className="chat-bubble__smart-include__heading-text-link">
                    {getTextAndLinks(senderRole, textOrLinkArray)}
                </Text>
            </Space>
            <span className="chat-bubble__smart-include__force-line-break" />
            <Space size={0} className="chat-bubble__smart-include">
                <a href={url} target="_blank" rel="noopener noreferrer">
                    <Image
                        className="chat-bubble__smart-include__image-preview-link"
                        src={image}
                        width={76}
                        tabIndex={0}
                        preview={false}
                    />
                </a>
                <Space direction="vertical" size={0}>
                    <Link
                        className="chat-bubble__smart-include__body-text-link"
                        underline={false}
                        href={url}
                        target="_blank"
                    >
                        {<Title level={3}>{title}</Title>}
                    </Link>
                    <span className="chat-bubble__smart-include__item-number">
                        #{itemNumber}
                    </span>
                    <Button
                        type="primary"
                        onClick={handleViewButtonClick}
                        role="link"
                        className="chat-bubble__smart-include__view-button"
                    >
                        View Item
                        <span className="sr-only">, opens in a new tab</span>
                    </Button>
                </Space>
            </Space>
        </>
    );
};

export default SmartIncludeChatBubble;
